angular.module('virtoCommerce.marketplaceModule')
    .controller('virtoCommerce.marketplaceModule.sellerImportProfileDetailsController', ['$scope', 'platformWebApp.bladeNavigationService', 'platformWebApp.settings.helper', 'virtoCommerce.marketplaceModule.webApi',
        function ($scope, bladeNavigationService, settingsHelper, marketplaceApi) {
            var blade = $scope.blade;
            blade.isLoading = true;

            function initializeBlade(data) {
                if (!blade.isNew) {
                    settingsHelper.fixValues(data.settings);
                }

                blade.currentEntity = !blade.isNew ? angular.copy(data) : { };
                blade.originalEntity = data;
                
                blade.command = {
                    sellerId: blade.sellerId,
                    sellerName: blade.sellerName,
                    importProfileId: blade.currentEntity.id,
                    importProfile: blade.currentEntity,
                };
                
                marketplaceApi.getImporters(function (data) {
                    blade.isLoading = false;
                    blade.importers = data.map(importer => {
                        settingsHelper.fixValues(importer.availSettings)
                        return importer;
                    });
                    if (!blade.isNew) {
                        $scope.selectImporter(data.find(isCurrentImporter));
                    }
                });
            }

            blade.refresh = function (parentRefresh) {
                initializeBlade(blade.currentEntity);

                if (parentRefresh) {
                    blade.parentBlade.refresh(true);
                }
            };

            $scope.setForm = function (form) { $scope.formScope = form; };

            if (!blade.isNew) {
                blade.toolbarCommands = [
                    {
                        name: "platform.commands.save", icon: 'fas fa-save',
                        executeMethod: function () {
                            $scope.saveChanges();
                        },
                        canExecuteMethod: canSave
                    },
                    {
                        name: "platform.commands.reset", icon: 'fa fa-undo',
                        executeMethod: function () {
                            angular.copy(blade.originalEntity, blade.currentEntity);
                        },
                        canExecuteMethod: isDirty
                    },
                    {
                        name: "platform.commands.delete", icon: 'fas fa-trash-alt',
                        executeMethod: function () {
                            $scope.bladeClose();
                            blade.parentBlade.delete(blade.originalEntity);
                        },
                        canExecuteMethod: function () { return true;  }
                    }
                ];

                blade.onClose = function (closeCallback) {
                    bladeNavigationService.showConfirmationIfNeeded(isDirty(), canSave(), blade, $scope.saveChanges, closeCallback, "marketplace.dialogs.seller-import-profile-save.title", "marketplace.dialogs.seller-import-profile-save.message");
                };

                function isDirty() {
                    return !angular.equals(blade.currentEntity, blade.originalEntity);
                }

                function canSave() {
                    return isDirty() && $scope.formScope && $scope.formScope.$valid;
                }
            }

            $scope.saveChanges = function () {
                blade.isLoading = true;
                
                settingsHelper.toApiFormat(blade.currentEntity.settings);

                if (blade.isNew) {
                    marketplaceApi.createSellerImportProfile(blade.command, function () {
                        $scope.bladeClose();
                        blade.refresh(true);
                    });
                } else {
                    marketplaceApi.updateSellerImportProfile(blade.command, function () {
                        blade.refresh(true);
                    });
                }
            }

            $scope.selectImporter = function (importer) {
                blade.importer = importer;
                if (blade.isNew) {
                    blade.currentEntity.settings = !blade.isNew && isCurrentImporter(importer) ? blade.originalEntity.settings : importer.availSettings;
                }
            }

            function isCurrentImporter(importer) {
                return importer.typeName === blade.currentEntity.dataImporterType;
            }

            blade.refresh();
        }
    ]);
